const UNSAFE_KEYS = new Set(['__proto__', 'prototype', 'constructor']);

const assertSafeKey = (key: string): void => {
  if (UNSAFE_KEYS.has(key)) {
    throw new TypeError(`Unsafe path segment: ${key}`);
  }
};

export function set<T extends Record<string, any>>(obj: T, path: string, value: any): T;
export function set<T>(obj: T, path: string, value: any): T;
export function set(obj: any, path: string, value: any): any {
  if (!obj || typeof obj !== 'object') {
    return obj;
  }

  const segments = path.split('.').filter(Boolean);
  if (!segments.length) {
    return obj;
  }

  for (let i = 0; i < segments.length; i += 1) {
    assertSafeKey(segments[i]);
  }

  let current: any = obj;

  for (let i = 0; i < segments.length; i += 1) {
    const key = segments[i];
    const isLast = i === segments.length - 1;

    if (isLast) {
      current[key] = value;
      break;
    }

    const next = Object.prototype.hasOwnProperty.call(current, key) ? current[key] : undefined;
    if (!next || typeof next !== 'object') {
      current[key] = {};
    }

    current = current[key];
  }

  return obj;
}
